export type Goal =
  | 'unknown'
  | 'chat'
  | 'networking'
  | 'learn'
  | 'travel'
  | 'relationship'
  | 'marriage'
  | 'serious_relationship'
  | 'where_it_goes'
  | 'make_friends'
  | 'meet_people';

export type SelectableGoal = Exclude<Goal, 'unknown'>;

export const selectableGoals: SelectableGoal[] = [
  'marriage',
  'relationship',
  'chat',
  'learn',
  'travel',
];

export const selectableGoalsV2: SelectableGoal[] = [
  'marriage',
  'serious_relationship',
  'where_it_goes',
  'make_friends',
  'meet_people',
];

export enum GoalBit {
  CHAT = 1, //2
  NETWORKING, //4
  LEARN, //8
  TRAVEL, //16
  RELATIONSHIP, //32
  MARRIAGE, //64
  SERIOUS_RELATIONSHIP = 10, //1024
  WHERE_IT_GOES, //2048
  MAKE_FRIENDS, //4096
  MEET_PEOPLE, //8192
}

const goalToBit: {[goal in SelectableGoal]: GoalBit} = {
  chat: GoalBit.CHAT,
  learn: GoalBit.LEARN,
  make_friends: GoalBit.MAKE_FRIENDS,
  marriage: GoalBit.MARRIAGE,
  meet_people: GoalBit.MEET_PEOPLE,
  networking: GoalBit.NETWORKING,
  relationship: GoalBit.RELATIONSHIP,
  serious_relationship: GoalBit.SERIOUS_RELATIONSHIP,
  travel: GoalBit.TRAVEL,
  where_it_goes: GoalBit.WHERE_IT_GOES,
};

export function unpackGoalsBits(goalsBits?: number): SelectableGoal[] {
  const result: SelectableGoal[] = [];
  if (goalsBits) {
    for (const goal in goalToBit) {
      if ((goalsBits & (1 << goalToBit[goal as SelectableGoal])) !== 0) {
        result.push(goal as SelectableGoal);
      }
    }
  }
  return result;
}

export function packGoalsBits(goals: SelectableGoal[]): number {
  let result = 0;
  for (const goal of goals) {
    result |= 1 << goalToBit[goal];
  }
  return result;
}
